import { supabase } from '../supabase';

export const getClients = () =>
  supabase.from('clients').select('*').order('created_at', { ascending: false });

export const getClient = (id) =>
  supabase.from('clients').select('*').eq('id', id).single();

export const createClient = (data) =>
  supabase.from('clients').insert({
    ...data,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  }).select().single();

export const updateClient = (id, data) =>
  supabase.from('clients').update({ ...data, updated_at: new Date().toISOString() }).eq('id', id);

export const deleteClient = (id) =>
  supabase.from('clients').delete().eq('id', id);

export const getClientsByStatus = (status) =>
  supabase.from('clients').select('*').eq('status', status).order('created_at', { ascending: false });
